import React, { useState } from 'react';
import { matchSorter } from 'match-sorter';
import ModalCadastro from '../_base/modal-cadastro';
import FormGroupHeader from '../_base/form-group-header';
import Errors from '../_base/errors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import EquipeService from '../../services/equipe-service';
import ProdutoService from '../../services/produto-service';

import lib from '../../helpers/lib';

import './styles.scss';

export default function ModalCadastroEquipeCarteira(props) {
  const { showModal, setShowModal, onClose, carteira: ref_carteira } = props;

  const emptyCarteira = {
    usuario: {},
    equipe: {}
  };

  const [carteira, setCarteira] = React.useState({ ...emptyCarteira });
  const [carteiraClientes, setCarteiraClientes] = React.useState([]);
  const [carteiraRepresentadas, setCarteiraRepresentadas] = React.useState([]);
  const [clientes, setClientes] = React.useState([]);
  const [representadas, setRepresentadas] = React.useState([]);
  const [filteredClientes, setFilteredClientes] = React.useState([]);
  const [filteredRepresentadas, setFilteredRepresentadas] = React.useState([]);
  const [errors, setErrors] = React.useState({});

  const [carteiraCategorias, setCarteiraCategorias] = useState([]);
  const [filterProdutos, setFilterProdutos] = useState('');

  React.useEffect(() => {
    getClientes();
    getRepresentadas();
  }, []);

  React.useEffect(() => {
    reset();

    if (ref_carteira?.usuario?.usuarioId?.length && ref_carteira?.equipe?.equipeId > 0) {
      getCarteira();
      getCategoriasSelecionadas();
    }
  }, [ref_carteira]);

  function reset() {
    setErrors({});
    setCarteira({ ...emptyCarteira });
    setCarteiraClientes([]);
    setCarteiraRepresentadas([]);
    setFilteredClientes(clientes);
    setFilteredRepresentadas(representadas);
  }

  async function getCarteira() {
    if (ref_carteira?.usuario?.usuarioId?.length && ref_carteira?.equipe?.equipeId > 0) {
      window.showLoader();

      let response = await EquipeService.getCarteiraEquipeUsuarioAsync(ref_carteira);
      let carteira = response.data.data;
      setCarteira(carteira);
      setCarteiraClientes(carteira.clientes);
      setCarteiraRepresentadas(carteira.representadas);
      window.hideLoader();
    }
  }

  async function getClientes() {
    let response = await EquipeService.listClientesAsync();
    let clientes = response.data.data;
    setClientes(clientes);
    setFilteredClientes(clientes);
  }

  async function getRepresentadas() {
    let response = await EquipeService.listRepresentadasAsync();
    let representadas = response.data.data;
    setRepresentadas(representadas);
    setFilteredRepresentadas(representadas);
  }

  async function getCategoriasSelecionadas() {
    let response = await ProdutoService.listCategoriasComProdutosAsync(
      ref_carteira?.usuario?.usuarioId,
      ref_carteira?.equipe?.equipeId
    );

    if (response?.data) {
      setCarteiraCategorias(response.data.data);
    }
  }

  async function saveAsync() {
    window.showLoader();

    setErrors({});

    let categoriasSelecionadas = carteiraCategorias.map((cat) => {
      let prodsSelecionados = cat.produtos.filter((prod) => !prod.selecionado);
      cat.produtos = prodsSelecionados;

      if (cat.produtos.length > 0) {
        return cat;
      }
    });

    categoriasSelecionadas = categoriasSelecionadas.filter((cat) => cat !== undefined);

    let requestModel = {
      usuario: carteira.usuario,
      equipe: carteira.equipe,
      clientes: carteiraClientes,
      representadas: carteiraRepresentadas,
      categorias: categoriasSelecionadas
    };

    let response = await EquipeService.saveCarteiraAsync(requestModel);

    if (response.status === lib.statusCode.ok) {
      window.hideLoader();

      setShowModal(false);
      return;
    }

    setErrors(response.data.errors);
    window.hideLoader();
  }

  async function toggleCollapseCategoria(categoriaId) {
    let categoria = carteiraCategorias.find((p) => p.produtoCategoriaId === categoriaId);

    if (categoria) {
      categoria.collapsed = !categoria.collapsed;
      setCarteiraCategorias([...carteiraCategorias]);
    }
  }

  async function toggleSelecaoCategoria(categoriaId) {
    let categoria = carteiraCategorias.find((p) => p.produtoCategoriaId === categoriaId);

    if (categoria) {
      categoria.selecionado = !categoria.selecionado;

      categoria.produtos.forEach((produto) => {
        produto.selecionado = categoria.selecionado;
      });

      setCarteiraCategorias([...carteiraCategorias]);
    }
  }

  async function toggleSelecaoProduto(produtoId, categoriaId) {
    let categoria = carteiraCategorias.find((p) => p.produtoCategoriaId === categoriaId);

    if (categoria) {
      let produto = categoria.produtos.find((p) => p.produtoId === produtoId);

      if (produto) {
        produto.selecionado = !produto.selecionado;

        let produtosSelecionados = categoria.produtos.filter((p) => p.selecionado);

        if (produtosSelecionados.length > 0) {
          categoria.selecionado = false;
        }

        if (produtosSelecionados.length === categoria.produtos.length) {
          categoria.selecionado = true;
        }

        setCarteiraCategorias([...carteiraCategorias]);
      }
    }
  }

  async function selectAllCategorias() {
    let carteiraAtual = carteiraCategorias;

    carteiraAtual.forEach((categoria) => {
      categoria.selecionado = true;

      categoria.produtos.forEach((produto) => {
        produto.selecionado = true;
      });
    });

    setCarteiraCategorias([...carteiraAtual]);
  }

  let filteredProdutos = carteiraCategorias || [];

  if (filterProdutos?.length > 0) {
    let filteredCategorias = matchSorter(carteiraCategorias || [], filterProdutos, {
      keys: ['nome', 'produtos.*.nome', 'produtos.*.codigoNaRepresentada']
    });

    filteredProdutos = filteredCategorias.map((categoria) => {
      const filteredProdutos = matchSorter(categoria.produtos, filterProdutos, {
        keys: ['nome', 'codigoNaRepresentada']
      });

      return {
        ...categoria,
        produtos: filteredProdutos
      };
    });
  }

  return (
    <ModalCadastro
      showModal={showModal}
      setShowModal={setShowModal}
      headerText={`${carteira?.usuario?.nome || ''} - ${carteira?.equipe?.nome || ''} - CARTEIRA`}
    >
      <div className="modal-body">
        <div className="row carteira">
          <div className="col-lg-6">
            <FormGroupHeader text="CLIENTES" />

            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              onChange={(e) => {
                setFilteredClientes(
                  matchSorter(clientes || [], e.target.value, {
                    keys: ['nomeFantasia', 'cnpj']
                  })
                );
              }}
            />

            <label className="list-item  mb-3">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    let lista = carteiraClientes || [];
                    for (let cliente of filteredClientes) {
                      if (lista.findIndex((x) => x.lojaId === cliente.lojaId) === -1)
                        lista.push(cliente);
                    }

                    setCarteiraClientes([...lista]);
                  } else {
                    let lista = carteiraClientes || [];
                    for (let cliente of filteredClientes) {
                      let index = lista.findIndex((x) => x.lojaId === cliente.lojaId);
                      if (index !== -1) lista.splice(index, 1);
                    }

                    setCarteiraClientes([...lista]);
                  }
                }}
              />{' '}
              Selecionar todos
            </label>

            <div style={{ maxHeight: '600px', overflow: 'auto' }}>
              {(filteredClientes || []).map((cliente, index) => (
                <div key={index} className="d-block">
                  <label className="list-item mb-3 d-flex align-items-start">
                    <input
                      type="checkbox"
                      checked={
                        (carteiraClientes || []).findIndex((c) => c.lojaId === cliente.lojaId) !==
                        -1
                      }
                      onChange={(e) => {
                        let lista = carteiraClientes || [];

                        if (e.target.checked) {
                          lista.push(cliente);
                          setCarteiraClientes([...lista]);
                        } else {
                          let index = lista.findIndex((x) => x.lojaId === cliente.lojaId);

                          if (index !== -1) {
                            lista.splice(index, 1);
                            setCarteiraClientes([...lista]);
                          }
                        }
                      }}
                    />
                    <div className="ps-1">
                      <div className="list-item  mb-3">
                        <span className="">
                          {cliente.nomeFantasia} {cliente.inadimplente ? ' - Bloqueado' : ''}
                        </span>
                        <br />
                        <span className="fantasia">
                          {cliente.razaoSocial} - {cliente.cnpj}
                        </span>
                        <br />
                        <span className="cnpj">
                          {cliente.logradouro} - {cliente.bairro} - {cliente.cidade}
                        </span>
                      </div>
                    </div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6">
            <FormGroupHeader text="REPRESENTADAS" />

            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              onChange={(e) => {
                setFilteredRepresentadas(
                  matchSorter(representadas || [], e.target.value, {
                    keys: ['nomeFantasia']
                  })
                );
              }}
            />

            <label className="list-item  mb-3">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    let lista = carteiraRepresentadas || [];
                    for (let representada of filteredRepresentadas) {
                      if (
                        lista.findIndex((x) => x.representadaId === representada.representadaId) ===
                        -1
                      )
                        lista.push(representada);
                    }

                    setCarteiraRepresentadas([...lista]);
                  } else {
                    let lista = carteiraRepresentadas || [];
                    for (let representada of filteredRepresentadas) {
                      let index = lista.findIndex(
                        (x) => x.representadaId === representada.representadaId
                      );
                      if (index !== -1) lista.splice(index, 1);
                    }

                    setCarteiraRepresentadas([...lista]);
                  }
                }}
              />{' '}
              Selecionar todos
            </label>

            {(filteredRepresentadas || []).map((representada, index) => (
              <div key={index} className="d-block">
                <label className="list-item mb-3">
                  <input
                    type="checkbox"
                    checked={
                      (carteiraRepresentadas || []).findIndex(
                        (c) => c.representadaId === representada.representadaId
                      ) !== -1
                    }
                    onChange={(e) => {
                      let lista = carteiraRepresentadas || [];

                      if (e.target.checked) {
                        lista.push(representada);
                        setCarteiraRepresentadas([...lista]);
                      } else {
                        let index = lista.findIndex(
                          (x) => x.representadaId === representada.representadaId
                        );

                        if (index !== -1) {
                          lista.splice(index, 1);
                          setCarteiraRepresentadas([...lista]);
                        }
                      }
                    }}
                  />{' '}
                  <div className="list-item  mb-3">
                    <span className="">{representada.nomeFantasia} </span>
                    <br />
                    <span className="fantasia">
                      {representada.razaoSocial} - {representada.cnpj}
                    </span>
                  </div>
                </label>
              </div>
            ))}
          </div>

          <div className="col-lg-6">
            <FormGroupHeader text="CATEGORIAS" />
            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              onChange={(e) => {
                setFilterProdutos(e.target.value);
              }}
              value={filterProdutos}
            />

            <button
              className="btn btn-link p-0 mb-3"
              onClick={() => {
                selectAllCategorias();
              }}
            >
              {' '}
              Adicionar todos
            </button>

            <div className="list-categorias" style={{ maxHeight: '600px', overflow: 'auto' }}>
              {(filteredProdutos || []).map((categoria, index) => (
                <ul key={index} className=" d-block p-0 mb-2">
                  <li className="list-item-header mb-1 d-flex align-items-center justify-content-between">
                    <div
                      className="selecao-categoria"
                      onClick={() => toggleSelecaoCategoria(categoria.produtoCategoriaId)}
                    >
                      <input
                        type="checkbox"
                        checked={categoria.selecionado}
                        onChange={() => toggleSelecaoCategoria(categoria.produtoCategoriaId)}
                      />

                      <span className="list-item-label">{categoria.nome}</span>
                    </div>

                    <div
                      className="collapse-categoria"
                      onClick={() => toggleCollapseCategoria(categoria.produtoCategoriaId)}
                    >
                      <FontAwesomeIcon
                        icon={categoria.collapsed ? faChevronDown : faChevronUp}
                        size={'xs'}
                      />
                    </div>
                  </li>

                  {!categoria.collapsed &&
                    (categoria.produtos || []).map((produto, indexProduto) => (
                      <div key={indexProduto}>
                        <div
                          className="list-item d-flex align-items-center ml-3"
                          onClick={() =>
                            toggleSelecaoProduto(produto.produtoId, categoria.produtoCategoriaId)
                          }
                        >
                          <input
                            type="checkbox"
                            checked={produto.selecionado}
                            onChange={() =>
                              toggleSelecaoProduto(produto.produtoId, categoria.produtoCategoriaId)
                            }
                          />

                          <span className="list-item-label">
                            {produto.codigoNaRepresentada} - {produto.nome}
                          </span>
                        </div>
                        {indexProduto + 1 < categoria.produtos.length ? <hr /> : null}
                      </div>
                    ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={saveAsync}>
          SALVAR
        </button>
      </div>
    </ModalCadastro>
  );
}
